module.exports = __webpack_public_path__ + "static/media/0.a124c03e.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/0.png
// module id = 967
// module chunks = 0